import React, { useMemo } from 'react';
import { Button } from '@veneer/core';
import { useDependencyManagerContext } from '../../../contexts/dependencyManager';

type TelemetryRequestButtonProps = {
  'data-testid': string;
  deviceFamily: string;
  disabled: boolean;
  loading: boolean;
  serialNumber: string;
  handleOnClick: () => void;
};

const TelemetryRequestButton: React.FC<TelemetryRequestButtonProps> = ({
  'data-testid': dataTestId,
  disabled,
  handleOnClick,
  loading,
  deviceFamily,
  serialNumber
}) => {
  const { translate } = useDependencyManagerContext();

  const buttonTextKey = disabled
    ? 'components.device-item.telemetry-request-button.data-requested'
    : 'components.device-item.telemetry-request-button.request-data';

  const ariaLabelKey = disabled
    ? 'components.device-item.telemetry-request-button.aria-label-requested'
    : 'components.device-item.telemetry-request-button.aria-label-request';

  const unknownDeviceName = translate('components.device-item.no-data.unknown');

  const requestButtonAnalyticsAttributes = useMemo(
    () => ({
      'data-gtm-category': 'linkClick',
      'data-gtm-id': `device-card-request-button-${serialNumber}`,
      'data-gtm-value': `request-data-${deviceFamily}-${serialNumber}`
    }),
    [serialNumber, deviceFamily]
  );

  return (
    <Button
      disabled={disabled}
      appearance={disabled ? 'primary' : 'secondary'}
      data-testid={dataTestId}
      onClick={handleOnClick}
      loading={loading}
      aria-label={translate(ariaLabelKey, {
        deviceFamily: deviceFamily || unknownDeviceName,
        serialNumber
      })}
      {...requestButtonAnalyticsAttributes}
    >
      {translate(buttonTextKey, {
        deviceFamily: deviceFamily || unknownDeviceName,
        serialNumber
      })}
    </Button>
  );
};

export default TelemetryRequestButton;
